import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "metricType", 
    "metricHelp", 
    "multiplierField", 
    "formulaPreview", 
    "formulaText",
    "conditionsSection",
    "conditionsToggleText",
    "conditionsChevron",
    "ordinalField",
    "metricOption",
    "metricCheckmark",
    "metricTypeRadio"
  ]

  connect() {
    this.updateMetricFields()
    this.updateMetricSelection()
  }

  updateMetricFields() {
    // Get the currently selected metric type from radio buttons
    const selectedRadio = this.metricTypeRadioTargets.find(radio => radio.checked)
    const metricType = selectedRadio ? selectedRadio.value : null
    
    if (!metricType) return
    
    // Show/hide multiplier field
    if (this.hasMultiplierFieldTarget) {
      if (metricType === 'weight' || metricType === 'length') {
        this.multiplierFieldTarget.classList.remove('hidden')
      } else {
        this.multiplierFieldTarget.classList.add('hidden')
      }
    }
    
    // Show/hide ordinal field
    if (this.hasOrdinalFieldTarget) {
      if (metricType === 'ordinal') {
        this.ordinalFieldTarget.classList.remove('hidden')
      } else {
        this.ordinalFieldTarget.classList.add('hidden')
      }
    }
    
    // Update formula preview
    if (this.hasFormulaTextTarget) {
      this.updateFormulaPreview(metricType)
    }
  }

  updateFormulaPreview(metricType) {
    let formula = ""
    
    switch(metricType) {
      case 'catch':
        formula = "Points = Base Points (awarded when fish is caught)"
        break
      case 'release':
        formula = "Points = Base Points (awarded when fish is released)"
        break
      case 'weight':
        formula = "Points = (Fish Weight × Multiplier) + Base Points"
        break
      case 'length':
        formula = "Points = (Fish Length × Multiplier) + Base Points"
        break
      case 'ordinal':
        formula = "Points = Base Points (awarded for Nth catch of species)"
        break
      default:
        formula = "Select a metric type to see the formula"
    }
    
    this.formulaTextTarget.textContent = formula
  }

  updateMetricSelection() {
    // Get the currently selected metric type
    const selectedRadio = this.metricTypeRadioTargets.find(radio => radio.checked)
    const selectedMetricType = selectedRadio ? selectedRadio.value : null
    
    // Update visual states for all options
    this.metricOptionTargets.forEach(option => {
      const metricType = option.dataset.metricType
      const isSelected = metricType === selectedMetricType
      
      // Update option styling
      if (isSelected) {
        option.classList.remove('border-gray-300')
        option.classList.add('border-blue-600', 'ring-2', 'ring-blue-600', 'bg-blue-50')
      } else {
        option.classList.remove('border-blue-600', 'ring-2', 'ring-blue-600', 'bg-blue-50')
        option.classList.add('border-gray-300')
      }
    })
    
    // Update checkmark visibility
    this.metricCheckmarkTargets.forEach(checkmark => {
      const metricType = checkmark.dataset.metricType
      const isSelected = metricType === selectedMetricType
      
      if (isSelected) {
        checkmark.classList.remove('opacity-0')
        checkmark.classList.add('opacity-100')
      } else {
        checkmark.classList.remove('opacity-100')
        checkmark.classList.add('opacity-0')
      }
    })
  }

  cancel(event) {
    event.preventDefault()
    
    // Clear the turbo frame to go back to the empty state
    const turboFrame = this.element.closest('turbo-frame')
    if (turboFrame) {
      turboFrame.innerHTML = ''
    }
  }

  toggleConditions(event) {
    event.preventDefault()
    
    if (this.conditionsSectionTarget.classList.contains('hidden')) {
      this.conditionsSectionTarget.classList.remove('hidden')
      this.conditionsToggleTextTarget.textContent = 'Hide Conditions'
      // Rotate chevron down
      if (this.hasConditionsChevronTarget) {
        this.conditionsChevronTarget.style.transform = 'rotate(180deg)'
      }
    } else {
      this.conditionsSectionTarget.classList.add('hidden')
      this.conditionsToggleTextTarget.textContent = 'Show Conditions'
      // Rotate chevron back up
      if (this.hasConditionsChevronTarget) {
        this.conditionsChevronTarget.style.transform = 'rotate(0deg)'
      }
    }
  }
}